import { render, staticRenderFns } from "./institution-filters.vue?vue&type=template&id=ac595bc2&scoped=true&lang=pug&"
import script from "./institution-filters.vue?vue&type=script&lang=ts&"
export * from "./institution-filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac595bc2",
  null
  
)

export default component.exports